import {ErrorhandleService} from '../../agent/service/errorhandle.service';
import {ErrorhandleFactory} from '../factory/errorhandlerfactory';
import {RequestService} from '../service/request.service';
import {SessionService} from '../service/session.service';
import {Router} from '@angular/router';

export let ErrorhandlerProvider = {
  provide: ErrorhandleService,
  useFactory: ErrorhandleFactory,
  deps: [SessionService, RequestService, Router]
};



// WEBPACK FOOTER //
// ./src/app/shared/provider/errorhandlerprovider.ts